export default function initAccordion(root = document) {
  const accordions = root.querySelectorAll('.accordion');

  if (!accordions.length) return;

  accordions.forEach((accordion) => {
    const headers = accordion.querySelectorAll('.accordion-header');

    headers.forEach(header => {
      if (header.dataset.bound === "1") return;
      header.dataset.bound = "1";

      header.addEventListener('click', function (e) {
        const item = this.closest('.accordion-item');
        if (!item) return;

        if (e.target.closest('.close-indicator')) {
          e.preventDefault();
          e.stopPropagation();
          item.classList.remove('active');
          this.setAttribute('aria-expanded', 'false');
          return;
        }

        const isActive = item.classList.contains('active');

        if (isActive) {
          item.classList.remove('active');
          this.setAttribute('aria-expanded', 'false');
          return;
        }

        accordion.querySelectorAll('.accordion-item.active').forEach(i => {
          i.classList.remove('active');
          i.querySelector('.accordion-header')?.setAttribute('aria-expanded', 'false');
        });

        item.classList.add('active');
        this.setAttribute('aria-expanded', 'true');

        setTimeout(() => {
          item.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 100);
      });
    });
  });
}
